module.exports = __webpack_public_path__ + "static/media/wav.c4680d84.svg";